/**
 * Constantes compartidas del módulo de Facturación.
 *
 * Extraídas de `pages/Billing.jsx` en el refactor preventivo de iteración 66
 * para que los subcomponentes (`DocView`, `GroupedItemsView`, `Dialog`, etc.)
 * puedan vivir en archivos separados sin duplicar literales.
 *
 * Nota: los iconos van como referencia directa al símbolo de lucide-react,
 * no como cadena. Cualquier consumidor importa `KIND_ICON[kind]` y lo renderiza
 * como componente React: `<KIND_ICON.invoice size={14} />`.
 */
import { Receipt, Truck, Undo2 } from "lucide-react";

export const KIND_LABEL = {
  invoice: "Factura",
  delivery_note: "Albarán",
  credit_note: "Abono",
};

export const KIND_PILL = {
  invoice: "bg-[#6E8B3D] text-white border-[#556C2E]",
  delivery_note: "bg-neutral-800 text-white border-neutral-900",
  credit_note: "bg-amber-50 text-amber-800 border-amber-300",
};

export const KIND_ICON = {
  invoice: Receipt,
  delivery_note: Truck,
  credit_note: Undo2,
};

/** Máximo número de líneas permitido en un documento. */
export const MAX_LINES = 20;

/**
 * Formatea un ISO timestamp a `dd/mm/aaaa hh:mm` (locale `es`).
 * Devuelve `"—"` si llega vacío y la cadena original si no parsea.
 */
export function formatDateTime(iso) {
  if (!iso) return "—";
  try {
    return new Date(iso).toLocaleString("es", {
      year: "numeric", month: "2-digit", day: "2-digit",
      hour: "2-digit", minute: "2-digit",
    });
  } catch {
    return iso;
  }
}
